import { PopupCenter } from "./popup";
import Config from "../config/config";
import { UseNavigation, UseTableGames } from "../hooks";
import { query_params } from './params';

const openGame = (gameId, lang, User, signIn, params) => {
  const tableGames = UseTableGames();
  const { navigate } = UseNavigation();
  switch (gameId) {
    case "spinPoker":
      User.keepAlive().then((response) => {
        if (response.status) {
          tableGames.playPoker({
            lang: lang,
            callback: (url) => {
              PopupCenter({
                url: url,
                title: "LeaderPoker",
                w: window.screen.width * 0.8,
                h: window.screen.height * 0.8,
              });
              //window.open(url, "_self");
            },
          });
        } else {
          signIn.open({
            onSuccess: () =>
              tableGames.playPoker({
                lang: lang,
                callback: (url) => {
                  PopupCenter({
                    url: url,
                    title: "LeaderPoker",
                    w: window.screen.width * 0.8,
                    h: window.screen.height * 0.8,
                  });
                  //window.open(url, "_self");
                },
              }),
          });
        }
      });
      break;
    case "leaderPoker":
      let dev = window.getDevice() === "web" ? "" : "m";
      User.keepAlive().then((response) => {
        let url = Config.TableGames.LeaderPoker.replace("{platform}", dev)
        if(Object.keys(params || {}).length > 0) url = url.concat(`&${query_params(params)}`)

        if (response.status) {
          PopupCenter({
            url,
            title: "LeaderPoker",
            w: window.screen.width * 0.8,
            h: window.screen.height * 0.8,
          });
        } else {
          signIn.open({
            onSuccess: () =>
              PopupCenter({
                url,
                title: "LeaderPoker",
                w: window.screen.width * 0.8,
                h: window.screen.height * 0.8,
              }),
          });
        }
      });
      break;
    case "playtechLiveCasino":
      PopupCenter({
        url: "/".concat(
          lang,
          `/play/liveCasino?vendor=playtechcasino&game=rol&lang=${lang}&table=&mod=`
        ),
        title: "LiveCasino",
      });
      break;
    case "evolutionLiveCasino":
      PopupCenter({
        url: "/".concat(
          lang,
          `/play/liveCasino?vendor=evolution&game=roulette&table=&lang=${lang}`
        ),
        title: "LiveCasino",
      });
      break;
    case "leaderRoulette":
      PopupCenter({
        url: "/".concat(lang, `/play/liveCasino?vendor=LeaderRoulette`),
        title: "LiveCasino",
      });
      break;
    case "egtRoulette":
      PopupCenter({
        url: `/${lang}/playSlot?catid=5&operator=508&game=20201&provider=null&name=EGT Roulette`,
        title: "LiveCasino",
        navigate: navigate,
      });
      break;
    case "egtRoulette1":
      PopupCenter({
        url: `/${lang}/playSlot?catid=5&operator=508&game=11&provider=null&name=EGT Roulette`,
        title: "LiveCasino",
        navigate: navigate,
      });
      break;
    case "pragmaticLiveCasino":
      PopupCenter({
        url: `/${lang}/playSlot?catid=63&operator=542&game=102&provider=913&name=PragmaticPlay%20Live`,
        title: "LiveCasino",
        navigate: navigate,
        w: window.innerWidth * 0.8,
        h: (window.innerWidth * 0.8) / 1.69,
      });
      break;
    default:
      if (gameId) navigate("/".concat(lang, '/play/', gameId));
  }
};
const openNavLink = (item, lang, User, signIn) => {
  const { navigate } = UseNavigation();
  switch (item.action.type) {
    case "play":
      openGame(item.action.params.gameId, lang, User, signIn);
      break;
    case "navigate":
    default:
      if (item.url){
        item?.action?.params?.external ? window.location.assign(item.url) : navigate("/".concat(lang, item.url), item?.action?.params);
      }
  }
};

export default { openNavLink, openGame };
